import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

// material-ui
import { makeStyles, useTheme } from '@material-ui/styles';
import { Box, Grid, Stack, Typography, useMediaQuery } from '@material-ui/core';

// project imports
import AuthWrapper2 from '../AuthWrapper2';
import AuthCardWrapper from '../AuthCardWrapper';
import FirebaseForgotPassword from '../firebase-forms/FirebaseForgotPassword';
import BackgroundPattern3 from 'ui-component/cards/BackgroundPattern3';
import Logo from 'assets/images/logo-RGB.svg';

// assets
import imgMain from 'assets/images/auth/img-forgotpass.svg';

const useStyles = makeStyles({
    authImage: {
        maxWidth: '100%',
        margin: '0 auto',
        display: 'block',
        width: '200px'
    },
    heading: {
        color: '#FFFFFF',
        fontStyle: 'normal',
        fontWeight: '700',
        fontSize: '17px',
        lineHeight: '20px'
    },
    mBottom: {
        marginBottom: '45px'
    }
});

// ============================|| AUTH2 - FORGOT PASSWORD ||============================ //

const ForgotPassword = () => {
    const classes = useStyles();
    const theme = useTheme();
    const matchDownSM = useMediaQuery(theme.breakpoints.down('sm'));
    const matchDownMD = useMediaQuery(theme.breakpoints.down('md'));

    return (
        <AuthWrapper2>
            <Grid container justifyContent={matchDownSM ? 'center' : 'space-between'} alignItems="center">
                <Grid item md={6} lg={6} xs={12} sx={{ minHeight: '100vh' }}>
                    <Grid
                        sx={{ minHeight: '100vh' }}
                        container
                        alignItems={matchDownSM ? 'center' : 'flex-start'}
                        justifyContent={matchDownSM ? 'center' : 'space-between'}
                    >
                        <Grid
                            item
                            xs={12}
                            container
                            justifyContent="center"
                            alignItems="center"
                            sx={{ minHeight: { xs: 'calc(100vh - 68px)', md: 'calc(100vh - 152px)' } }}
                        >
                            <Stack justifyContent="center" alignItems="center" spacing={5} m={2}>
                                <Box component={RouterLink} to="/" sx={{ display: { xs: 'block', md: 'none' } }}>
                                    <img src={Logo} alt="logo" />
                                </Box>
                                <AuthCardWrapper border={matchDownMD}>
                                    <Grid container spacing={2}>
                                        <Grid item sx={{ display: { xs: 'none', md: 'block' } }}>
                                            <RouterLink to="/">
                                                <img src={Logo} alt="logo" className={classes.mBottom} />
                                            </RouterLink>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Stack spacing={1}>
                                                <Typography
                                                    color={theme.palette.secondary.main}
                                                    gutterBottom
                                                    variant={matchDownSM ? 'h3' : 'h2'}
                                                >
                                                    Forgot Password?
                                                </Typography>
                                                <Typography variant="caption" fontSize="16px">
                                                    Enter your registered email id here we will send you a magic link to reset the password.
                                                </Typography>
                                            </Stack>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <FirebaseForgotPassword />
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Grid item container direction="column" alignItems="end" xs={12}>
                                                <Typography
                                                    component={RouterLink}
                                                    to="/pages/register/register2"
                                                    variant="subtitle5"
                                                    sx={{ textDecoration: 'none' }}
                                                >
                                                    Don’t have an account?
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </AuthCardWrapper>
                            </Stack>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item md={6} lg={6} sx={{ position: 'relative', alignSelf: 'stretch', display: { xs: 'none', md: 'block' } }}>
                    <BackgroundPattern3>
                        {/* <Grid item container justifyContent="center">
                            <Grid item xs={12}>
                                <img alt="Auth method" src={imgMain} className={classes.authImage} />
                            </Grid>
                        </Grid> */}
                    </BackgroundPattern3>
                </Grid>
            </Grid>
        </AuthWrapper2>
    );
};

export default ForgotPassword;
